import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import { Close as CloseIcon, Search as SearchIcon } from "@mui/icons-material";

export default function SearchField({
  value,
  onChange,
  placeholder = "Search...",
}) {
  const styles = {
    root: {
      flex: 1,
      minWidth: 0,
      alignSelf: "center",
      py: 0.5,
      pl: 1,
      pr: 4,
    },
    field: {
      "& .MuiOutlinedInput-root": { borderRadius: 1.5 },
      "& .MuiOutlinedInput-input": {
        paddingTop: "4.5px",
        paddingBottom: "4.5px",
      },
    },
    icon: { color: "background.textMuted" },
    clearButton: { color: "background.textMuted" },
  };

  return (
    <Box sx={styles.root}>
      <TextField
        fullWidth
        size="small"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        sx={styles.field}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" sx={styles.icon} />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  aria-label="Clear search"
                  onClick={() => onChange("")}
                  sx={styles.clearButton}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />
    </Box>
  );
}
